"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _AccordionSection = _interopRequireDefault(require("./AccordionSection"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const generateSections = (sections, setExpanded, expanded, titleElement) => sections.map((_ref, i) => {
  let {
    key,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_AccordionSection.default, _extends({
    expanded: expanded,
    key: key || i,
    sectionKey: key === null || key === void 0 ? void 0 : key.toString(),
    setExpanded: setExpanded,
    titleElement: titleElement
  }, props));
});

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Accordion](https://docs.vanillaframework.io/patterns/accordion/).
 *
 * The sidebar accordion, used in listing pages or as navigation, can hold multiple navigation items or to be used as a filter for content.
 */
const Accordion = _ref2 => {
  let {
    className,
    expanded,
    externallyControlled,
    onExpandedChange,
    sections,
    titleElement,
    ...asideProps
  } = _ref2;
  const [expandedSection, setExpandedSection] = (0, _react.useState)(expanded);
  const setExpanded = (id, title) => {
    setExpandedSection(id);
    onExpandedChange && onExpandedChange(id, title);
  };
  return /*#__PURE__*/_react.default.createElement("aside", _extends({
    className: (0, _classnames.default)(className, "p-accordion")
  }, asideProps, {
    role: "tablist",
    "aria-multiselectable": "true"
  }), /*#__PURE__*/_react.default.createElement("ul", {
    className: "p-accordion__list"
  }, generateSections(sections, setExpanded, externallyControlled ? expanded : expandedSection, titleElement)));
};
var _default = exports.default = Accordion;